<template>
<div>
    <base-header v-once pageName="메모하기" :popup="true"></base-header>
    
    <section id="wrap" class="h100">
        <div class="sms-input memo">
            <textarea ref="memo" id="memo" :value="memo" v-on:input="checkText($event)" placeholder="메모 내용을 입력해주세요."></textarea>
            <span><em>{{memoLength}}</em>/500</span>
        </div>
    </section>  
    <div class="btnWrap">
        <button type="button" class="red" @click="saveMyCustMemo()">등록</button>
    </div>  
</div>
</template>

<script>
export default {
  data() {
      return{
          kwkkey: "",
          custDiv: "",
          memoDiv: "",
          memo: "",
          memoLength: 0
      };
  },
  methods: {
    checkText: function(e){  
        if(e.target.id == 'memo' ){
            if(e.target.value.length > 500){
                e.target.value = e.target.value.substr(0,500);
            }else{
                this.memo = e.target.value;
            }
              this.memoLength = e.target.value.length;
        }
    },
    validate() { // 유효성 체크
        // console.log("Memo.vue validate this.memo:",this.memo);
            
        if (this.$utils.stringUtil.isNull(this.memo)) {
            alert("메모를 입력해주세요.");
            return false;
        }      
      return true;
    },
    saveMyCustMemo: function(){
      var that = this;
      var validate = this.validate();
      if(!validate) {
        return;
      }
      if(!confirm("저장하시겠습니까?")){
        return;
      }

      var params = {kwkkey:this.kwkkey,custDiv:this.custDiv,memoDiv:this.memoDiv,memo:this.memo,amntPsblYn:'Y'};
      console.log("Memo.vue api.myCstmr.saveMyCustMemo params:",params);

        this.$api.myCstmr.saveMyCustMemo(params)
          .then(function() {
            var child = {
              name: 'memo-save-complete',
              data: {res:'ok'}
            };
            that.$utils.nativeIf.outbound.sendChildData(child);
          })
          .catch(function(error) {
              alert(error.rtMsg);
          });
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'memo-pop-param'){  // 부모창에서 받은 정보.
            console.log("Memo.vue mounted this.$store.getters.parent.data", parent.data);
            this.kwkkey = parent.data.kwkkey;
            this.custDiv = parent.data.custDiv;
            this.memoDiv = parent.data.memoDiv;
        }
  }
};
</script>
